import * as motion from 'motion/react-client';

import NextImage, { NextImageProps } from '@/decodo/components/atoms/Image';
import { Text } from '@/decodo/components/atoms/Text';

export function Features({
  features,
  icon,
  delayFactor = 0,
}: {
  delayFactor?: number;
  features: string[];
  icon?: NextImageProps;
}) {
  return (
    <motion.ul
      variants={{}}
      transition={{
        delayChildren: delayFactor,
        staggerChildren: 0.1,
      }}
      className='grid grid-cols-2 flex-wrap gap-x-8 gap-y-6 md:flex md:justify-center'
    >
      {features.map((feature, i) => (
        <motion.li
          key={feature}
          variants={{
            initial: { opacity: 0, y: 8 },
            animate: { opacity: 1, y: 0, transition: { duration: 1.5 } },
          }}
          className='flex items-center gap-x-3'
        >
          {!!icon && (
            <NextImage
              {...icon}
              classNames={{ container: 'size-6', image: 'size-full' }}
            />
          )}
          <Text
            classNames={{
              wrapper: 'font-medium dark:text-base-black text-gray-950 shrink-0',
            }}
          >
            {feature}
          </Text>
        </motion.li>
      ))}
    </motion.ul>
  );
}
